import { useState, useEffect } from 'react'

export type Country = 'AR' | 'EC'

const STORAGE_KEY = 'signwiz_country'

function detectCountry(): Country {
  const stored = localStorage.getItem(STORAGE_KEY) as Country | null
  if (stored === 'AR' || stored === 'EC') return stored

  const lang = navigator.language || ''
  if (lang.toLowerCase().includes('ec')) return 'EC'
  return 'AR'
}

export function useCountry() {
  const [country, setCountryState] = useState<Country>('AR')

  useEffect(() => {
    setCountryState(detectCountry())
  }, [])

  function setCountry(c: Country) {
    localStorage.setItem(STORAGE_KEY, c)
    setCountryState(c)
  }

  return { country, setCountry }
}
